import { useCallback, useState } from 'react';
import { PureRelatedOrders } from '../RelatedOrders/PureRelatedOrders';

interface NewRelatedOrdersProps {
  platform: General.PlatformUpperCase;
  externalBuyerId: string;
  storeId: string;
  onSelect: (trade: Conversation.Trade.Vo | null) => void;
  onClear: () => void;
}
export const NewRelatedOrders = (props: NewRelatedOrdersProps) => {
  const { platform, externalBuyerId, storeId, onSelect, onClear } = props;
  const [relatedTradeId, setRelatedTradeId] = useState<string>('');

  const handleSelectOrder = useCallback(
    (trade: Conversation.Trade.Vo | null) => {
      onSelect(trade);
      setRelatedTradeId(trade?.externalTradeId ?? '');
    },
    [onSelect],
  );

  const handleClearOrder = useCallback(() => {
    setRelatedTradeId('');
    onClear();
  }, [onClear]);

  return (
    <PureRelatedOrders
      canEdit
      autoSelectFirst
      relatedTradeId={relatedTradeId}
      platform={platform}
      externalBuyerId={externalBuyerId}
      storeId={storeId}
      onSelect={handleSelectOrder}
      onClear={handleClearOrder}
    />
  );
};
